import api from '@/services/api'
import { Message } from 'element-ui'

class Auth {

  /**
   * 获取国家区号列表
   */
  getCountryCode () {
    return api.get('/sms/country_code/list ').then(res => {
      return res.data
    })
  }

  /**
   * 获取验证码
   * @param {
   * telephone 是	
   * captcha	 是	采用阿里人机验证传1，否则0
   * data	     是	前端获取的阿里信息
   * type	     是	6
   * } params 
   */
  fetchSMSCode (params) {
    return api.post('/auth/verify_code', params).then(res => {
      if (res.status === 200) {
        Message.success('验证码已发送')
      }
      return res.data
    })
  }

  handleError (data) {
    if (data.status !== 200) {
      Message.error(data.data.message)
    }
  }

  /**
   * 获取机构注册状态
   * @param {
   * telephone
   * code} params 
   */
  getRegisterStatus (params) {
    return api.get('/schools/register_status', { params }).then(res => {
      console.log(res, 2736)
      this.handleError(res)
      return res.data
    })
  }

  /**
   * 注册机构
   * @param {
   * } params 
   */
  registerSchool (params) {
    return api.post('/schools/direct_register', params).then(res => {
      this.handleError(res)
      return res.data
    })
  }

  /**
   * 获取已注册手机号的机构列表
   * @param {
   * token } params 
   */
  getRegisterSchools (params) {
    return api.get('/schools/telephone_register_schools', { params }).then(res => {
      return res.data
    })
  }
}

export default new Auth()
